import { useLingui } from '@lingui/react';
import { Box, Group, Stack, Text } from '@mantine/core';
import EventItem, { EventItemMultiple } from './EventItem';
import { ThemeText } from '../../Atoms/ThemeText';
import { useContext } from 'react';
import { EventsContext } from '../../Service/Context/EventsContext';

const EventsMonthPane = ({ month, year, eventSums, eventDates }) => {
  const { i18n } = useLingui();
  const { filter } = useContext(EventsContext) ?? {};
  const { agencyModeActive } = filter ?? { agencyModeActive: false };
  const { length } = eventDates;
  if (length === 0) {
    return null;
  }

  const regularDateLength = eventDates.filter((e) => e.type === 'REGULAR_DATE').length;
  const appointmentsLength = eventDates.filter((e) => e.type === 'APPOINTMENT').length;

  // Sort by start date
  const sortedDates = [...eventDates].sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());

  // Helper to get YYYY-MM-DD key from Date
  const getDayKey = (d) => {
    const dt = new Date(d);
    return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
  };

  const getKey = (eventDate) => {
    const { eventId, date, type } = eventDate;
    // Hide group view for agency mode
    if (type === 'REGULAR_DATE' && !agencyModeActive) {
      return `${eventId}__${getDayKey(date)}`;
    }
    return eventDate.id;
  };

  // Group by eventId + calendar day
  const groupedEvents = sortedDates.reduce((map, d) => {
    const key = getKey(d);
    if (!map.has(key)) map.set(key, []);
    map.get(key)?.push(d);
    return map;
  }, new Map());

  // Build components
  const eventsOfMonth = Array.from(groupedEvents.entries()).map(([key, dates]) =>
    dates.length === 1 ? (
      <EventItem key={key} bookingEventDate={dates[0]} />
    ) : (
      <EventItemMultiple key={key} bookingEventDates={dates} />
    ),
  );

  if (eventSums) {
    eventSums.forEach((e) => {
      monthSumOpen += e.sumOpen;
    });

    eventSums.forEach((e) => {
      monthSumConfirmed += e.sumConfirmed;
    });
  }

  return (
    <div className="events-month-indent">
      <Box
        p="md"
        mt={15}
        sx={(theme) => ({
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[9] : theme.colors.gray[0],
          borderRadius: 10,
        })}
      >
        <Group>
          <ThemeText size="lg" weight="bold">{`${i18n._(`month.${month}`)} ${year}`}</ThemeText>
          {regularDateLength > 0 && <Text size="xs" color="dimmed">{`${regularDateLength} Events`}</Text>}
          {!agencyModeActive && appointmentsLength > 0 && (
            <Text size="xs" color="dimmed">{`${appointmentsLength} Termine`}</Text>
          )}
        </Group>
      </Box>
      <Stack mt="sm">{eventsOfMonth}</Stack>
    </div>
  );
};

export default EventsMonthPane;
